import React, { useContext, useEffect, useState } from "react";
import * as Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import AppleLogin from "react-apple-login";
import { SignupContext } from "src/context/SignupContext/SignupContext";
import Api from "src/network";
import { AppleButton } from "./SocialButtons";
import DefaultCommModal from "./DefaultCommModal";
import * as SignInActions from "src/store/actions/SignInActions/SignInAction";
import { useDispatch, useSelector } from "react-redux";
import { extractCommunityInfo } from "../../../Utils/extractCommunityInfo";
import DefaultCommunityChangePage from "./SignIn/DefaultCommunityChangePage";

const baseURL = process.env.REACT_APP_SERVICES_API_OTHER;
const AppleClientId = process.env.REACT_APP_APPLE_CLIENT_ID; // Service Id
const AppleRedirectUri = `${baseURL}/jsonindex/apple-id`; // Your redirect URI

const defaultState = {
  community: "Default Community",
  tenantId: "",
};

function AppleSignUp(props) {
  const history = useHistory();
  const emailAction = useSelector((state) => state.emailActionReducer);
  const { invitedCommunityName, invitedCommunityId, invitedEmailId } =
    extractCommunityInfo(emailAction);
  const [loading, setLoading] = useState(false);
  const [showDefaultCommModal, setShowDefaultCommModal] = useState(false);
  const [state, setState] = useState({ ...defaultState });
  const signupContext = useContext(SignupContext);
  const dispatch = useDispatch();
  const SignInReducer = useSelector((state) => state.SignInReducer);
  const [isUserBlocked, setIsUserBlocked] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const { isAuthenticating } = SignInReducer;

  useEffect(() => {
    const { appleSignUp, community, tenantId } = signupContext?.signupState;
    if (appleSignUp) {
      setState((prevState) => ({
        ...prevState,
        community: community,
        tenantId: tenantId,
      }));
      setShowDefaultCommModal(true);
    }
  }, []);

  const handleTenantBlockedLogic = (userDetails) => {
    const count = userDetails?.userData?.communityFollowNames?.length ?? 0;
    if (
      userDetails?.userData?.communityStatus === "communityBlocked" ||
      userDetails?.userData?.currentCommunityStatus == 0
    ) {
      if (count > 1) setIsUserBlocked(true);
      else if (count === 1) history.push("/defaultCommunity");
    }
  };

  const onCloseDefaultCommunitykModal = () => {
    setIsUserBlocked(false);
    if (
      userDetails?.userData?.communityStatus === "communityBlocked" ||
      userDetails?.userData?.currentCommunityStatus == 0
    ) {
      dispatch(SignInActions.signOut());
    }
  };

  const onCloseModal = () => {
    setShowDefaultCommModal(false);
    dispatch(SignInActions.setAuthenticating(false));
    //reset all values
    setState({ ...defaultState });
    //reset signup context data
    signupContext?.resetSignupState();
  };

  const handleMakeDefault = async (tenantId) => {
    let formdata = new FormData();
    formdata.append("userDefaultTenantId", tenantId);
    Api.setDefaultTenant(formdata)
      .then((res) => {
        console.log("handleMakeDefault res", res);
        autheticate(tenantId, state?.community, true);
      })
      .catch((err) => {
        alert("Default Community selection failed!");
      });
  };

  const isBtnDisabled = () => {
    return (
      !state?.community ||
      (state?.community).toLowerCase() === "default community" ||
      loading
    );
  };

  const onSignUp = async (tenantId) => {
    const finalTenantId = invitedCommunityId || tenantId;
    // if there is no community selected
    if (isBtnDisabled()) return;
    await handleMakeDefault(finalTenantId);
  };

  const autheticate = async (tenantId, community, isSignUpFlow) => {
    // if (isAuthenticating) return; // Prevent multiple clicks
    // dispatch(SignInActions.setAuthenticating(true)); // Disable all buttons
    try {
      setLoading(true);
      const finalCommunity = invitedCommunityName || community;
      const blockedTenants = ["tenant_blocked", "Inactive Tenant"];
      const updatedCommunity = blockedTenants.includes(finalCommunity)
        ? ""
        : finalCommunity;
      const finalTenantId = invitedCommunityId || tenantId;
      await Api.getUserData(finalTenantId, updatedCommunity);
      if (
        finalCommunity === "tenant_blocked" ||
        finalCommunity === "Inactive Tenant"
      ) {
        const res = await Api.fetchLoginUser();
        setUserDetails(res?.data);
        handleTenantBlockedLogic(res?.data);
      }
      setTimeout(async () => {
        if (invitedCommunityId && invitedCommunityName) {
          const formdata = new FormData();
          formdata.append("communityID", invitedCommunityId);
          formdata.append("communityName", invitedCommunityName);
          formdata.append("followStat", 1); // 1 means follow
          formdata.append("sourceApp", "WebApp");

          await Api.followUnfollowCommunity(formdata);
        }
      }, 500);

      // set cookies
      if (finalCommunity !== "tenant_blocked" && finalCommunity !== "Inactive Tenant") {
        Cookies.set("signInStatus", true);
        history.push("/Home");
      }
      // sessionStorage.setItem("userData", JSON.stringify(result));

      if (isSignUpFlow) {
        //for signup flow
        // close default community selection popup
        setShowDefaultCommModal(false);
        // reset signup context data
        signupContext?.resetSignupState();
        // set isNewUser flag to true
        dispatch(SignInActions?.updateIsNewUser(true));
      }

      dispatch(SignInActions.authUser());
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
      dispatch(SignInActions.setAuthenticating(false));
    }
  };

  const onSuccess = async (response) => {
    dispatch(SignInActions.setAuthenticating(true));
    console.log("RESPONSE->>", response);
    if (!response?.error) {
      let formdata = new FormData();
      formdata.append("oAuthCode", response?.authorization?.code);
      formdata.append("appType", "web");
      try {
        const result = await Api.appleSignup(formdata);
        const { status } = result?.data || {};
        if (
          status &&
          String(status).toLowerCase() ===
            "Thank you for SignUp using your appleid account, Skopic has created a profile for you and a temporary Skopic password has been emailed.".toLowerCase()
        ) {
          signupContext?.setSignupState({
            appleSignUp: true,
            community: invitedCommunityName || "",
            tenantId: "",
          });
          setState({
            ...defaultState,
            community: invitedCommunityName || "",
          });
          setShowDefaultCommModal(true);
        } else if (
          status &&
          String(status).toLowerCase() ===
            "Thank you for Signing using your appleid account".toLowerCase()
        ) {
          autheticate(
            result.data?.userTenantId,
            result.data?.userTenant,
            false,
          );
        }
      } catch (e) {
        console.error(e);
      }
    } else {
      console.log("ERROR->>", response);
      dispatch(SignInActions.setAuthenticating(false));
    }
  };

  const isAppleSDKLoaded =
    typeof window !== "undefined" &&
    !!window.AppleID &&
    typeof AppleClientId === "string" &&
    AppleClientId.trim() !== "";

  const handleAppleClickFallback = () => {
    alert("Apple Sign-In is unavailable in this browser view. Please tap the menu or share button and select 'Open in Safari'.");
  };

  return (
    <>
      {isAppleSDKLoaded ? (
        <AppleLogin
          clientId={AppleClientId} // Your Services ID
          redirectURI={AppleRedirectUri} // Your redirect URI
          usePopup={true}
          callback={onSuccess} // Catch the response
          scope="email name"
          responseMode="query"
          render={(
            renderProps, //Custom Apple Sign in Button
          ) => (
            <AppleButton
              onClick={renderProps.onClick}
              loading={loading}
              isAuthenticating={isAuthenticating}
            />
          )}
        />
      ) : (
        <AppleButton
          onClick={handleAppleClickFallback}
          loading={loading}
          isAuthenticating={isAuthenticating}
        />
      )}
      {showDefaultCommModal && (
        <DefaultCommModal
          open={showDefaultCommModal}
          onClose={onCloseModal}
          loading={loading}
          // email={state?.email}
          // password={state?.password}
          community={state?.community}
          tenantId={invitedCommunityId || state?.tenantId}
          // displayName={state?.displayName}
          onSignUp={onSignUp}
          disabled={isBtnDisabled()}
          invitedCommunityName={invitedCommunityName}
        />
      )}
      <DefaultCommunityChangePage
        isUserBlocked={isUserBlocked}
        onCloseDefaultCommunitykModal={onCloseDefaultCommunitykModal}
        userDetails={userDetails}
      />
    </>
  );
}

export default AppleSignUp;
